import { Controller } from "@hotwired/stimulus";

// Polls the Oscar site-generator status endpoint while a run is in
// progress and reloads the page when it finishes (either way — the
// server renders the results or the failure state).
export default class extends Controller {
  static targets = ["label", "verb"];
  static values = {
    url: String,
    interval: { type: Number, default: 2500 },
  };

  // Claude-style fun gerunds cycled while Oscar works — flavor only,
  // the real status renders underneath.
  VERBS = [
    "Warming up", "Stretching", "Shadowboxing", "Wordsmithing",
    "Kerning", "Color-matching", "Chalking up", "Flexing",
    "Sparring with adjectives", "Bowing in", "Drilling headlines",
    "Taping wrists", "Hydrating", "Manifesting", "Zenning",
    "Cutting weight (from paragraphs)", "Pep-talking the hero",
    "Rolling with the copy",
  ];

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue);
    if (this.hasVerbTarget) {
      // Shuffle once so every run feels different, then cycle.
      this.verbs = [...this.VERBS].sort(() => Math.random() - 0.5);
      this.verbIndex = 0;
      this.verbTimer = setInterval(() => this.nextVerb(), 2200);
      this.nextVerb();
    }
  }

  disconnect() {
    clearInterval(this.timer);
    clearInterval(this.verbTimer);
  }

  nextVerb() {
    this.verbTarget.textContent = `${this.verbs[this.verbIndex % this.verbs.length]}…`;
    this.verbIndex += 1;
  }

  async poll() {
    let data;
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } });
      if (!response.ok) return;
      data = await response.json();
    } catch {
      return; // transient network blip — keep polling
    }

    if (data.status === "completed" && data.redirect_url) {
      clearInterval(this.timer);
      clearInterval(this.verbTimer);
      window.location = data.redirect_url;
    } else if (data.status === "completed" || data.status === "failed" || data.status === "none") {
      clearInterval(this.timer);
      window.location.reload();
    } else if (this.hasLabelTarget && data.status_label) {
      this.labelTarget.textContent = data.status_label;
    }
  }
}
